// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__G3bvz","text1":"styles_text1__xRlRc","text2":"styles_text2__kdjRa"};